<template lang="pug">
  article.pt-250.pb-px
    transition(name="fade")
      main(v-if="doc")
        //- blau menu
        nav.md-w-xl.mx-auto.mb-194.select-none.text-center
          ul.md-inline-block.font-blau.leading-none.list-reset
            //- items
            li.relative(v-for="item in doc.acf.blau_menu")
              //- title
              wp-link.home__menu-itm.hover-text-gray-300.trans-color-quicker.hover-z-10.text-68.md-text-8vw.xl-text-100.break-all.md-break-normal(:link="item.link")
                span.block.p-2.-mt-4(v-html="item.link.title")
              //- hover image
              wp-link.home__menu-img.block.mt-30.mb-82.md-my-0.md-absolute.md-pl-20.md-transly_-50.md-opacity-0(style="left:100%; top:50%;", :link="item.link")
                figure.w-7x12.mx-auto.md-w-13vw.md-max-w-300
                  resp-img.block.w-1x2.mx-auto.md-w-full(:src="item.image.url", :alt="item.image.alt")
                  figcaption.pt-30.text-13.font-unica.md-absolute.md-pt-15.leading-sm {{item.caption}}
          .mt-82.md-mt-40.w-full.flex.justify-center
            wp-link(:link="doc.acf.arrowed_link")
              link-with-arrow {{doc.acf.arrowed_link.title}}
        flex-body(:rows="doc.acf.body")
        article-collection.mt-200(:id="doc.acf.collection")
</template>

<script>
import { mapState } from 'vuex'
import AppFooter from '@/components/AppFooter'
import LinkWithArrow from '@/components/LinkWithArrow'
import FlexBody from '@/components/FlexBody/FlexBody'
import ArticleCollection from '@/components/ArticleCollection'
import wpLink from '@/components/WPLink'
import RespImg from '@/components/RespImg'
export default {
  name: 'Home',
  data () {
    return {
      doc: null
    }
  },
  computed: {
    ...mapState(['site'])
  },
  methods: {
    async getDoc () {
      const qry = this.$route.query
      if (qry.id && qry.preview) return this.$store.dispatch('getPreview', { type: 'pages', ...qry })
      return this.$store.dispatch('getPage', 'home')
    }
  },
  created () {
    this.getDoc().then(doc => { this.doc = doc })
  },
  components: { AppFooter, FlexBody, LinkWithArrow, wpLink, ArticleCollection, RespImg },
  metaInfo () {
    return {
      meta: this.$store.getters.meta({})
    }
  }
}
</script>

<style scoped>
@import '../style/_settings.css';
@media (hover:hover) and (--bkpt-md) {
  .home__menu-itm{
    & + .home__menu-img{ opacity: 0; transition: opacity 150ms; }
    &:hover + .home__menu-img{ opacity:1; transition: opacity 600ms;}
  }
}
</style>
